import moment from "moment";
import Config from "../config/main";

let t = str => str;  // all strings here have to be inside t() to be recognizable by translation extraction script

let timeZone = Config.main.changeTimeFiltersTimeZone;

export const predefinedDateRanges = [
    {
        id: 'all',
        name: t('All'),
        fromDate: 0,
        toDate: timeZone
            ? moment().utc().utcOffset(timeZone).endOf('day').unix()
            : moment().endOf('day').unix()
    },
    {
        id: 'today',
        name: t("Today"),
        fromDate: timeZone
            ? moment.utc().add("day", 0).utcOffset(timeZone).startOf('day').unix()
            : moment().subtract(0, "days").startOf('day').unix(),
        toDate: timeZone
            ? moment.utc().add("day", 0).utcOffset(timeZone).endOf('day').unix()
            : moment().endOf('day').unix()
    },
    {
        id: 'yesterday',
        name: t("Yesterday"),
        fromDate: timeZone
            ? moment().utc().subtract(1, "days").utcOffset(timeZone).startOf('day').unix()
            : moment().subtract(1, "days").startOf('day').unix(),
        toDate: timeZone
            ? moment().utc().subtract(1, "days").utcOffset(timeZone).endOf('day').unix()
            : moment().subtract(1, "days").endOf('day').unix()
    },
    {
        id: 'last_2_days',
        name: t("Last 2 days"),
        fromDate: timeZone
            ? moment().utc().subtract(1, "days").utcOffset(timeZone).startOf('day').unix()
            : moment().subtract(1, "days").startOf('day').unix(),
        toDate: timeZone
            ? moment().utc().utcOffset(timeZone).endOf('day').unix()
            : moment().endOf('day').unix()
    },
    {
        id: 'week',
        name: t("Last Week"),
        fromDate: timeZone
            ? moment().utc().subtract(6, "days").utcOffset(timeZone).startOf('day').unix()
            : moment().subtract(6, "days").startOf('day').unix(),
        toDate: timeZone
            ? moment().utc().utcOffset(timeZone).endOf('day').unix()
            : moment().endOf('day').unix()
    },
    {
        id: 'month',
        name: t("Last Month"),
        fromDate: timeZone
            ? moment().utc().subtract(1, "months").utcOffset(timeZone).startOf('day').unix()
            : moment().subtract(1, "months").startOf('day').unix(),
        toDate: timeZone
            ? moment().utc().utcOffset(timeZone).endOf('day').unix()
            : moment().endOf('day').unix()
    }
];